export function ScrollToSection(elementId: string) {
  var el = document.getElementById(elementId);
  if (el) {
    el.scrollIntoView({ behavior: "smooth" });
  }
}
